import {useEffect, useState} from 'react';
import {getFavouriteItems} from 'service/HardwareService';
import {genericMessageHandler, usePromise} from 'shared/helpers';
import {useNotificationContext} from 'contexts/NotificationContext';
import {saveManageFavourites} from 'service/SettingsService';
import {useGetQuickProductsQuery} from 'components/customer/Product/store/productApi';
import {getProductParams} from 'hooks/preCacheProducts';
import {useJobContext} from 'contexts/JobContext';

export const useFavourites = () => {
    const [loading, setLoading] = useState(false);
    const {notify} = useNotificationContext();
    const [products, setProducts] = useState([]);
    const [sundries, setSundries] = useState([]);
    const {room} = useJobContext();

    const {
        data: allProducts,
        isLoading,
        isFetching,
    } = useGetQuickProductsQuery(getProductParams({room}));

    const saveFavourites = async () => {
        const updatedProductList = [];
        const updatedSundryList = [];

        products.forEach((product, key) => {
            updatedProductList.push({cabinetId: product.id, order: key + 1});
        });

        sundries.forEach((sundry, key) => {
            updatedSundryList.push({sundryId: sundry.id, order: key + 1});
        });
        try {
            setLoading(true);
            const response = await saveManageFavourites(
                updatedProductList,
                updatedSundryList
            );

            genericMessageHandler(notify, {message: response}, 'success');

            setLoading(false);
        } catch (error) {
            genericMessageHandler(notify, error);
            setLoading(false);
        }
    };

    useEffect(() => {
        let cleanUp = () => {};
        setLoading(true);

        const sundriesPromise = getFavouriteItems();

        cleanUp = usePromise(
            ([sundries]) => {
                if (allProducts) {
                    setProducts(
                        allProducts
                            .filter((product) => Number(product.favourites) > 0)
                            .map((product) => ({
                                id: product.type,
                                imageUrl: product.image,
                                name: product.text,
                                ...product,
                            }))
                            .sort((a, b) => a.favourites - b.favourites)
                    );
                }
                setSundries(
                    sundries.sundry_items.sort(
                        (a, b) => a.favourites - b.favourites
                    )
                );
                setLoading(false);
            },
            [sundriesPromise],
            (error) => {
                genericMessageHandler(notify, error);
            }
        );

        return cleanUp;
    }, [allProducts]);

    return {
        loading: loading || isLoading || isFetching,
        sundries,
        products,
        setProducts,
        setSundries,
        saveFavourites,
    };
};
